import React, {Component} from 'react';
import {Line} from 'react-chartjs-2';
import {injectIntl} from 'react-intl';
import {getAccumulation, getChartDataByDay, getGradients, getSum} from './budget_charts_util';

class CostChart extends Component {
	getChartData() {
		const {itemsOutsideProjectPeriod, isEstimatedInNewPoints} = this.props;
		const {formatMessage} = this.props.intl;
		const {actualPerDay, forecastPerDay, costRemainingPerDay, project, labels} = this.props.data;
		const {gradientStroke, gradientFill, gradientStrokeActual, gradientFillActual} = getGradients();

		const actualPerDayData = getChartDataByDay({project, dayData: actualPerDay, projection: false});
		const plannedPerDayData = getChartDataByDay({project, dayData: forecastPerDay});

		const datasets = [
			{
				label: formatMessage({id: 'project_budget.planned_cost'}),
				borderColor: gradientStroke,
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointBackgroundColor: '#cecbf7',
				pointHoverBorderColor: '#fff',
				pointRadius: 0,
				fill: true,
				backgroundColor: gradientFill,
				borderWidth: 2,
				data: getAccumulation(plannedPerDayData),
			},
			{
				label: formatMessage({id: 'insights.component.list.column.actualCost'}),
				borderColor: gradientStrokeActual,
				pointBackgroundColor: 'rgba(234, 248, 255, 0.8)',
				pointHoverBorderColor: '#fff',
				pointHoverRadius: 0,
				pointHoverBorderWidth: 2,
				pointRadius: 0,
				fill: true,
				backgroundColor: gradientFillActual,
				borderWidth: 2,
				data: getAccumulation(actualPerDayData),
			},
		].concat(itemsOutsideProjectPeriod ? itemsOutsideProjectPeriod : []);

		if (isEstimatedInNewPoints) {
			//if using story point we should not show the planned_cost
			datasets.splice(0, 1);

			//But we need to show the Forecast
			const firstNullIndex = actualPerDayData.findIndex(number => number === null);
			if (firstNullIndex !== -1) {
				const notProjected = getSum(getChartDataByDay({project, dayData: costRemainingPerDay, projection: false}), getChartDataByDay({project, dayData: actualPerDay, projection: false}));
				const notProjectedAccumulation = getAccumulation(notProjected);
				const remainingAcc = getAccumulation(getChartDataByDay({project, dayData: costRemainingPerDay, projection: false}));

				const projectedCost = getSum(getChartDataByDay({project, dayData: costRemainingPerDay, projection: true}), getChartDataByDay({project, dayData: actualPerDay, projection: true}));
				projectedCost[firstNullIndex - 1] = 0;
				const projectedRevenueAcc = getAccumulation(projectedCost, notProjectedAccumulation[firstNullIndex - 1]);
				projectedRevenueAcc[firstNullIndex - 1] -= remainingAcc[firstNullIndex - 1];

				datasets.push({
					label: formatMessage({id: 'common.forecast'}),
					borderColor: gradientStrokeActual,
					pointHoverRadius: 0,
					pointHoverBorderWidth: 2,
					pointBackgroundColor: 'transparent',
					pointHoverBorderColor: gradientStrokeActual,
					pointRadius: 0,
					fill: false,
					backgroundColor: 'transparent',
					borderWidth: 2,
					data: projectedRevenueAcc,
					borderDash: [4, 2],
				});
			}
		}

		return {
			datasets,
			labels,
		};
	}

	render() {
		return <Line data={this.getChartData()} options={this.props.options} plugins={this.props.plugins} redraw />;
	}
}

export default injectIntl(CostChart);
